import { useState } from "react";
import {
  Megaphone,
  CheckCircle,
  ArrowRight,
} from "lucide-react";
import { useNavigate } from "react-router-dom";

function Announcements() {
  const navigate = useNavigate();

  const [data, setData] = useState([
    {
      id: 1,
      author: "IT Administrator",
      subject: "TP LINK WiFi Network Update",
      message:
        "The new TP LINK router has been installed and configured successfully. Please refer to the WiFi Passwords section for the latest network credentials.",
      status: "active",
      date: "07 Jul 2026",
    },
  ]);

  const markResolved = (id) => {
    const updated = data.map((item) =>
      item.id === id
        ? { ...item, status: "resolved" }
        : item
    );

    setData(updated);
  };

  return (
    <div className="space-y-8">

      {/* PAGE HEADER */}
      <div
        className="rounded-[24px] lg:rounded-[32px] p-6 lg:p-8 text-white relative overflow-hidden"
        style={{
          background:
            "linear-gradient(135deg,#C00000 0%,#8B0000 45%,#111111 100%)",
        }}
      >
        <div className="absolute top-0 right-0 w-72 h-72 bg-white/10 rounded-full blur-3xl"></div>

        <div className="relative z-10">
          <h1 className="text-2xl lg:text-4xl font-bold">
            Company Announcements
          </h1>

          <p className="mt-3 text-white/80">
            Stay updated with company news,
            IT updates and important notifications.
          </p>
        </div>
      </div>

      {/* ANNOUNCEMENTS */}
      {data.map((item) => (
        <div
          key={item.id}
          className="
          bg-white
          rounded-[24px]
          border
          border-gray-200
          shadow-[0_8px_30px_rgb(0,0,0,0.06)]
          overflow-hidden
          hover:shadow-[0_15px_40px_rgb(0,0,0,0.10)]
          transition-all
          "
        >
          {/* HEADER */}
          <div className="p-5 lg:p-6 border-b border-gray-100">

            <div
              className="
              flex
              flex-col
              lg:flex-row
              lg:items-center
              lg:justify-between
              gap-4
              "
            >
              <div className="flex items-start gap-4">

                <div
                  className="
                  w-12
                  h-12
                  rounded-xl
                  bg-red-100
                  flex
                  items-center
                  justify-center
                  shrink-0
                  "
                >
                  <Megaphone
                    size={22}
                    className="text-[#C00000]"
                  />
                </div>

                <div>
                  <h2 className="text-lg lg:text-xl font-bold text-gray-800">
                    {item.subject}
                  </h2>

                  <p className="text-sm text-gray-500 mt-1">
                    Posted by {item.author}
                  </p>

                  <p className="text-xs text-gray-400 mt-1">
                    {item.date}
                  </p>
                </div>

              </div>

              <span
                className={`
                px-4
                py-2
                rounded-full
                text-sm
                font-medium
                w-fit

                ${
                  item.status === "active"
                    ? "bg-red-100 text-[#C00000]"
                    : "bg-green-100 text-green-700"
                }
                `}
              >
                {item.status === "active"
                  ? "Active"
                  : "Resolved"}
              </span>
            </div>

          </div>

          {/* BODY */}
          <div className="p-5 lg:p-6">

            <p className="text-gray-700 leading-relaxed">
              {item.message}
            </p>

            {/* QUICK ACTION */}
            <div
              onClick={() => navigate("/dashboard/wifi")}
              className="
              mt-6
              p-4
              rounded-2xl
              border
              border-red-100
              bg-red-50
              cursor-pointer
              hover:bg-red-100
              transition-all
              "
            >
              <div className="flex items-center justify-between">

                <div>
                  <h3 className="font-semibold text-[#C00000]">
                    WiFi Passwords
                  </h3>

                  <p className="text-sm text-gray-600 mt-1">
                    View latest network credentials
                  </p>
                </div>

                <ArrowRight
                  className="text-[#C00000]"
                  size={20}
                />
              </div>
            </div>

            {/* ACTION BUTTON */}
            {item.status === "active" && (
              <div className="mt-8 flex justify-end">

                <button
                  onClick={() => markResolved(item.id)}
                  className="
                  w-full
                  lg:w-auto
                  flex
                  items-center
                  justify-center
                  gap-2
                  bg-[#C00000]
                  hover:bg-[#9D0000]
                  text-white
                  px-5
                  py-3
                  rounded-xl
                  transition-all
                  "
                >
                  <CheckCircle size={18} />

                  Mark as Resolved
                </button>

              </div>
            )}

          </div>
        </div>
      ))}
    </div>
  );
}

export default Announcements;